{
  "analysis.saved.tab": "Saved analyses",
  "analysis.saved.author.title": "Build an analysis",
  "analysis.saved.author.description": "Combine your saved Life metrics with one bounded dimension and window.",
  "analysis.saved.author.noMetrics": "No saved metrics yet",
  "analysis.saved.author.noMetricsDescription": "Create a metric in Life before building a reusable analysis.",
  "analysis.saved.author.name": "Analysis name",
  "analysis.saved.author.measures": "Measures",
  "analysis.saved.author.measuresHint": "Choose up to four metrics from the same Life schema.",
  "analysis.saved.author.dimension": "Dimension",
  "analysis.saved.author.window": "Window",
  "analysis.saved.author.comparison": "Compare with the previous window",
  "analysis.saved.author.comparisonUnavailable": "Comparisons are available for bounded totals without a time-series dimension.",
  "analysis.saved.author.save": "Save analysis",
  "analysis.saved.author.saveError": "The analysis could not be saved. Check its current Life fields and metrics.",
  "analysis.saved.dimension.none": "No dimension",
  "analysis.saved.dimension.day": "Time · day",
  "analysis.saved.dimension.week": "Time · week",
  "analysis.saved.dimension.month": "Time · month",
  "analysis.saved.window.all": "All time",
  "analysis.saved.window.day": "Today",
  "analysis.saved.window.week": "This week",
  "analysis.saved.window.month": "This month",
  "analysis.saved.window.rolling": "Rolling 7 days",
  "analysis.saved.browse.title": "Saved analyses",
  "analysis.saved.browse.description": "Run a reusable definition against your current Life records.",
  "analysis.saved.browse.measureCount": "{{count}} measure",
  "analysis.saved.browse.measureCount_plural": "{{count}} measures",
  "analysis.saved.browse.run": "Run",
  "analysis.saved.browse.empty": "No saved analyses",
  "analysis.saved.browse.emptyDescription": "Choose at least one measure and save your first definition.",
  "analysis.saved.results.title": "Results",
  "analysis.saved.results.description": "{{count}} bounded result rows.",
  "analysis.saved.results.measure": "Measure",
  "analysis.saved.results.previous": "previous {{value}}",
  "analysis.saved.results.empty": "No matching results",
  "analysis.saved.missing": "Not available"
}
